export enum TokenSortMethod {
  RANK = 'Rank',
  TRADER = 'Trader',
  SWAP_VOLUME = 'Swap Volume',
  PRE_VOLUME = 'Perp Volume',
  TOTAL_VOLUME = 'Total Volume',
  REWARDS = 'Rewards',
}
